import { useEffect } from "react";
import { useNavigate } from "react-router";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { findGetParameter } from "../../components/utilities/UtilityFunctions";

export default function LRRankings() {
  let _search = window.location.search || "";
  let _organizationId = findGetParameter("storeId");
  if (!_organizationId) {
    _organizationId = findGetParameter("organizationId");
  }
  if (!_organizationId) {
    _organizationId = findGetParameter("organization");
  }
  if (!_organizationId) {
    _organizationId = findGetParameter("gameStoreId");
  }
  if (!_organizationId) {
    _organizationId = findGetParameter("gameStore");
  }

  let _circuitId = findGetParameter("circuitId");
  if (!_circuitId) {
    _circuitId = findGetParameter("league");
  }
  const navigate = useNavigate();
  useEffect(() => {
    navigate(
      _circuitId
        ? `/rankings/${_circuitId}?${_search}`
        : _organizationId
        ? `/organization/rankings/${_organizationId}${_search}`
        : "/"
    );
    // eslint-disable-next-line
  }, []);
  return <ModalLoadingFull />;
}
